import { FC } from 'react';
import { generateSequentialNumbers } from '../../../../../services/generateSequentialNumbers';
import classNames from 'classnames';
import styles from './styles.module.css';

const times = generateSequentialNumbers(0, 23).map((time) => `${time}:00`);
const TimelineHead: FC = () => {
  return (
    <>
      {times.map((time) => (
        <div
          key={time}
          className={classNames(styles.timelineHead, styles.timeHeadCell)}
        >
          {time === '0:00' ? null : (
            <div className={styles.timeAnnotation}>{time}</div>
          )}
        </div>
      ))}
    </>
  );
};

export default TimelineHead;
